module.exports = {
   components: [],
   routes: [],
   sub_routes: [{
         name: "Report",
         path: "reports/report",
         component: () => import('./report/report.vue'),
      }, 
   ]
}